if (!customElements.get('hp-premium-team')) {
  customElements.define('hp-premium-team', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-hp-team-slide]')];
      if (this.slides.length < 2) return;
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-current')));
      this.lastChange = performance.now();
      this.visible = true;
      this.hovered = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const resetClock = () => { this.lastChange = performance.now(); };
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; resetClock(); }, options);
      this.addEventListener('focusout', resetClock, options);
      document.addEventListener('visibilitychange', resetClock, options);
      this.reducedMotion.addEventListener('change', resetClock, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
          resetClock();
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
      }
      this.timer = setInterval(() => {
        // Reuse the hero cadence while giving the visible team area its own clock.
        const interval = customElements.get('hp-premium-hero')?.rotationInterval ?? 7000;
        if (this.reducedMotion.matches || document.hidden || !this.visible || this.hovered || this.contains(document.activeElement) || performance.now() - this.lastChange < interval) return;
        const nextIndex = (this.index + 1) % this.slides.length;
        const nextImage = this.slides[nextIndex].querySelector('img');
        if (nextImage && (!nextImage.complete || !nextImage.naturalWidth)) return;
        this.index = nextIndex;
        this.slides.forEach((slide, index) => {
          const current = index === this.index;
          slide.classList.toggle('is-current', current);
          slide.setAttribute('aria-hidden', String(!current));
        });
        resetClock();
      }, 250);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
